import React,{useContext} from 'react';
import './FreshList.css';
import FreshProducts from './FreshProducts';
import SimpleContext from './../../context/SimpleContext';
import { Badge } from 'react-bootstrap';
import NumberFormat from 'react-number-format';

const FreshProductsList = () => {

    const context = useContext(SimpleContext);

    let allProducts = [...context.FreshProductsList];
    const FreshIsShowOne = allProducts.filter(pr => pr.isShow === 1);

    return ( 
        <div className="freshMainH">
            <div className="freshbanner">
                <img src="https://apikala.com/images/Banners/mive169.jpg" className="bannerImg" alt="" />
                <div className="basketIcon" onClick={()=>context.handleHistoryreplace("/freshshopped")}>
                    <i className="fa fa-shopping-basket"></i>
                    <Badge className="FreshTopBadge">
                        <NumberFormat value={context.FRESHCartItems.length} displayType={'text'}/>
                    </Badge>
                </div>
            </div>
            <div className="freshProductsMain">
                
                {
                    FreshIsShowOne.length?
                    FreshIsShowOne.map((fr,i) =>
                        <div className="freshProductDiv" key={i}>
                            <FreshProducts
                                image={fr.ImgUrl}
                                name={fr.lev2Name}
                                id={fr.ID}
                            />
                        </div>
                    ):null
                }
            </div>
            <div className="searchFresh" onClick={context.handleCloseFreshSearch}>
                <i className="fa fa-search"></i>
            </div>
        </div>
    );
}
 
export default FreshProductsList;